export function getVisibleMarkers(markers, zoom) {
  if (!markers) return [];
  if (zoom < 5) return [];

  if (zoom < 6) {
    return markers.slice(0, Math.ceil(markers.length * 0.3));
  }

  return markers;
}
